import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://thinkway-api-producao.onrender.com'
});

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('@ThinkWay:token');
        if (token) {
            config.headers.Authorization = `${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

api.interceptors.response.use(
  response => response,
  error => {
    // Handle 401 errors globally (expired token)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('@ThinkWay:token');
      window.location.href = '/tw/login';
    }
    return Promise.reject(error);
  }
);

export default api;
